<template>
  <div class="app-page key-value b-modal bulma-dropdown">
    <vue-headful title="ALICE | Value Editor"></vue-headful>
    <div class="column-wrapper">
      <div class="single-page-full">
        <div class="collection-list">
          <div class="page-title">
            <div class="page-title-text">Value Editor</div>
            <div class="page-title-control">
              <b-dropdown aria-role="list" position="is-bottom-left">
                <div class="button is-small is-white" slot="trigger" role="button">
                  <font-awesome-icon icon="ellipsis-v"></font-awesome-icon>
                </div>
                <b-dropdown-item
                  aria-role="listitem"
                  class="collection-menu-item"
                  @click="toggleImportCollection(true)"
                >
                  <span class="icon">
                    <font-awesome-icon icon="file-import"></font-awesome-icon>
                  </span>
                  <span>Import collection</span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
          <div class="list-header">
            <div class="white-text">Collections</div>
            <div class="button is-white is-small" @click="toggleCreateCollectionModal(true)">
              <span>Add Collection</span>
            </div>
          </div>
          <div class="list-wrapper">
            <div
              v-for="collection in collectionList"
              :key="collection.id"
              class="list-item"
              :class="{'selected': collection.id === selectedCollectionId}"
              @click="selectCollection(collection.id)"
              >{{collection.collectionName}}</div>
        <!--     <b-dropdown aria-role="list" position="is-bottom-left">
                <div class="button is-small is-white" slot="trigger" role="button">
                  <font-awesome-icon icon="ellipsis-v"></font-awesome-icon>
                </div>
                <b-dropdown-item
                  aria-role="listitem"
                  class="collection-menu-item"
                  @click="toggleUpdateDisplayName(collection.collectionName,collection.id)"
                >
                  <span class="icon">
                    <font-awesome-icon icon="edit"></font-awesome-icon>
                  </span>
                  <span>Edit Display Name</span>
                </b-dropdown-item>
              </b-dropdown></div></div>  -->
            <div
              class="list-item"
              v-if="!collectionList || collectionList.length === 0"
            >No collection data.</div>
          </div>
        </div>
        <div class="collection-detail">
          <div class="result-title" v-if="selectedCollectionId && keyValueData">
            <div class="title-text">
              {{selectedCollection.collectionName}}
              <div class="tag is-rounded" v-if="!isLoading">{{keyValueData.totalElements}}</div>
            </div>
            <div class="title-tool">
              <div class="control search-bar">
                <input
                  id="val-search"
                  type="text"
                  class="input is-small"
                  placeholder="Search ..."
                  v-model="searchPhrase"
                  @keyup.enter="searchPage"
                />
              </div>
              <b-dropdown id="collection-detail-menu" aria-role="list" position="is-bottom-left">
                <div class="button is-small is-info is-transparent" slot="trigger" role="button">
                  <font-awesome-icon icon="ellipsis-v"></font-awesome-icon>
                </div>
                <b-dropdown-item
                  aria-role="listitem"
                  class="collection-menu-item"
                  @click="toggleAddColumn"
                >
                  <span class="icon">
                    <font-awesome-icon icon="plus-square"></font-awesome-icon>
                  </span>
                  <span>Add column</span>
                </b-dropdown-item>
                <b-dropdown-item
                  aria-role="listitem"
                  class="collection-menu-item"
                  @click="exportCollection"
                >
                  <span class="icon">
                    <font-awesome-icon icon="file-export"></font-awesome-icon>
                  </span>
                  <span>Export this collection</span>
                </b-dropdown-item>
                <hr class="dropdown-divider" />
                <b-dropdown-item
                  aria-role="listitem"
                  class="collection-menu-item"
                  @click="toggleDeleteCollection"
                >
                  <span class="icon">
                    <font-awesome-icon icon="trash-alt"></font-awesome-icon>
                  </span>
                  <span>Remove collection</span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="loading-wrapper loading-block" v-if="isLoading">
            <span>
              <i class="fas fa-spinner fa-spin"></i>
            </span>
          </div>

          <div class="result-wrapper" v-if="selectedCollectionId && keyValueData && !isLoading">
            <VueTabulator
                ref="tabulator"
                :integration="{ updateStrategy: 'REPLACE' }"
                v-model="keyValuePageData"
                :options="keyValueColumn"
                @cell-edited="onEditCell"
            />
          </div>
           <!-- add row -->
          <div
            class="floating-fab button is-info is-rounded"
            @click="addNewRow"
          >
            <span class="icon">
              <font-awesome-icon icon="plus"></font-awesome-icon>
            </span>
          </div>

          <!-- <div class="result-wrapper" v-if="selectedCollectionId && keyValueData">
            <editable-table
              v-if="!isLoading"
              :columns="keyValueColumn"
              :data="keyValuePageData"
              :temp-column="tempColumn"
              v-on:addRow="onAddRow"
              v-on:editRow="onEditRow"
              v-on:deleteRow="onDeleteRow"
              />
          </div> -->
          <div class="footer-bar" v-if="selectedCollectionId && keyValueData">
            <bootstrap-pagination
              v-if="!isLoading"
              v-model="valuePage"
              :total-rows="keyValueData.totalElements"
              :per-page="valuePageSize"
              align="left"
              size="sm"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              @change="togglePage"
            ></bootstrap-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="modal create-collection-modal" :class="{'is-active': createCollectionModalOpen }">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="card no-margin">
          <div class="card-title">Create New Collection</div>
          <div class="columns is-mobile card-form">
            <div class="column">
              <div class="field field-left">
                <label class="label">Collection Name</label>
                <div class="control is-expanded">
                  <input
                    class="input"
                    type="text"
                    placeholder="Enter name of collection"
                    v-model.trim="createCollectionData.collectionName"
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field field-right">
                <label class="label">Key name</label>
                <div class="control is-expanded">
                  <input
                    class="input"
                    type="text"
                    placeholder="Enter key or this collection"
                    v-model.trim="createCollectionData.keyName"
                  />
                </div>
              </div>
            </div>
          </div>
          <label class="label">Source Type</label>
          <div class="block">
            <b-radio v-model="createCollectionData.sourceType"
                name="name"
                class="mr-3"
                native-value="mongo">
                Data Store
            </b-radio>
            <b-radio v-model="createCollectionData.sourceType"
                name="name"
                native-value="elasticsearch">
                Full text search
            </b-radio>
          </div>
          <div class="card-action">
            <button
              class="button is-info"
              @click="confirmCreateCollection"
              :disabled="invalidCreateCollectionModal"
            >Create</button>
            <button
              class="button is-info is-inverted"
              @click="toggleCreateCollectionModal(false)"
            >Cancel</button>
          </div>
        </div>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="toggleCreateCollectionModal(false)"
      >&nbsp;</button>
    </div>
    <div class="modal import-collection-modal" :class="{'is-active': importCollectionOpen }">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="card no-margin">
          <div class="card-title">Import Collection</div>
          <div class="columns is-mobile card-form">
            <div class="column">
              <div class="field field-left">
                <label class="label">Collection file</label>
                <div class="control is-expanded">
                  <input
                    id="file-input"
                    class="input"
                    type="file"
                    :disabled="importCollectionLoading"
                    :accept="acceptCollectionPreset"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="card-action">
            <button
              class="button is-info"
              @click="importCollection"
              :disabled="importCollectionLoading"
            >Import</button>
            <button
              class="button is-info is-inverted"
              @click="toggleImportCollection(false)"
              :disabled="importCollectionLoading"
            >Cancel</button>
          </div>
        </div>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        :disabled="importCollectionLoading"
        @click="toggleImportCollection(false)"
      ></button>
    </div>
    <div id="download-area"></div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { BPagination } from 'bootstrap-vue';
// import Tabulator from 'tabulator-tables';
// import EditableTable from '../components/KeyValue/EditableTable.vue';
import alice from '../alice-api';

export default {
  name: 'key-value-editor',
  components: {
    // 'editable-table': EditableTable,
    'bootstrap-pagination': BPagination,
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      tabulatorInstance: null,
      options: {
        nestedFieldSeparator: false,
        columns: [],
        layout: 'fitColumns',
        maxHeight: '100%',
        height: '100%',
        placeholder: 'No data',
        reactiveData: true,
        columnMinWidth: 80,
        // columnMaxWidth: 200,
        headerSort: false,
      },
      acceptCollectionPreset: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
      showCollectionDropdown: false,
      selectedCollectionId: '',
      valuePage: 1,
      valuePageSize: 20,
      searchPhrase: '',
      tempColumn: [],
      createCollectionModalOpen: false,
      createCollectionData: {
        collectionName: '',
        keyName: '',
        sourceType: '',
      },
      importCollectionOpen: false,
      importCollectionLoading: false,
      isLoading: true,
    };
  },
  methods: {
    ...mapActions({
      loadCollectionList: 'keyvalue/loadCollectionList',
      createCollection: 'keyvalue/createCollection',
      deleteCollection: 'keyvalue/deleteCollection',
      getKeyValuePage: 'keyvalue/getKeyValuePage',
      getCollectionHeaderById: 'keyvalue/getCollectionHeaderById',
      addKeyValue: 'keyvalue/addKeyValue',
      updateKeyValue: 'keyvalue/updateKeyValue',
      deleteKeyValue: 'keyvalue/deleteKeyValue',
      updateLocalRowData: 'keyvalue/updateLocalRowData',
    }),
    async init() {
      await this.loadCollectionList();
      if (this.collectionList && this.collectionList[0]) {
        this.selectCollection(this.collectionList[0].id);
      }
    },
    async selectCollection(id) {
      // if (this.selectedCollectionId !== id) {
      this.isLoading = true;
      this.tempColumn = [];
      this.selectedCollectionId = id;
      this.valuePage = 1;
      this.searchPhrase = '';
      await this.getCollectionHeaderById({ collectionId: id });
      const responseKeyValuePage = await this.getKeyValuePage({
        collectionId: id,
        page: this.valuePage,
        size: this.valuePageSize,
        searchPhrase: this.searchPhrase,
      });
      // if content in keyValuePageData not match Collection
      const contentNotMatchCollection = responseKeyValuePage.content.filter((content) => content.collectionId !== this.selectedCollectionId);
      if (contentNotMatchCollection.length) {
        this.isLoading = true;
        this.selectCollection(this.selectedCollectionId);
      } else {
        this.isLoading = false;
      }
      // }
    },
    async searchPage() {
      this.valuePage = 1;
      this.togglePage(this.valuePage);
    },
    async togglePage(page) {
      this.tempColumn = [];
      await this.getKeyValuePage({
        collectionId: this.selectedCollectionId,
        page,
        size: this.valuePageSize,
        searchPhrase: this.searchPhrase,
      });
    },
    toggleCreateCollectionModal(state) {
      if (state) {
        this.createCollectionData = {
          collectionName: '',
          keyName: '',
          sourceType: 'mongo',
        };
      }
      this.createCollectionModalOpen = state;
    },
    async confirmCreateCollection() {
      const { collectionName, keyName, sourceType } = this.createCollectionData;
      await this.createCollection({
        collectionName,
        keyName: keyName.toLowerCase(),
        sourceType,
      });
      this.createCollectionModalOpen = false;
      this.createCollectionData = {
        collectionName: '',
        keyName: '',
        sourceType: 'mongo',
      };
      await this.loadCollectionList();
    },
    toggleDeleteCollection() {
      const collection = this.selectedCollection;
      this.$buefy.dialog.confirm({
        title: 'Remove confirmation',
        message: `Are you sure you are going to remove collection "${collection.collectionName}" ?`,
        cancelText: 'Keep It',
        confirmText: 'Remove',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async () => {
          await this.deleteCollection({ collectionId: collection.id });
          this.selectedCollectionId = '';
          await this.loadCollectionList();
        },
      });
    },
    /* toggleUpdateDisplayName(name, id) {
      this.$buefy.dialog.prompt({
        title: 'Update Collection Display Name',
        message: 'Please enter display name',
        inputAttrs: {
          placeholder: name,
          minlength: 1,
          value: '',
          title: 'Column name (will reset if not save new value)',
        },
        onConfirm: (rawValue) => {
          const value = rawValue.trim() || '';
          if (value.length > 0) {
            console.log(id);
            alice.updateCollectionDisplayName(value, id).then(async () => {
              this.importCollectionLoading = false;
              this.importCollectionOpen = false;
              this.$buefy.toast.open({
                type: 'is-success',
                message: 'Collection imported.',
                position: 'is-bottom',
                duration: 1000,
              });
              await this.loadCollectionList();
            })
              .catch(() => {
                this.importCollectionLoading = false;
                this.importCollectionOpen = false;
                this.$buefy.toast.open({
                  type: 'is-danger',
                  message: 'Collection import failed.',
                  position: 'is-bottom',
                  duration: 1000,
                });
              });
          }
        }
      });
    },  */
    toggleAddColumn() {
      this.$buefy.dialog.prompt({
        title: 'New column',
        message: 'Please enter column name',
        inputAttrs: {
          placeholder: 'e.g. new_column',
          minlength: 1,
          value: '',
          title: 'Column name (will reset if not save new value)',
        },
        onConfirm: (rawValue) => {
          const value = rawValue.trim() || '';
          if (value.length > 0) {
            // Check if duplicate with other column
            if (this.keyValueHeader && this.keyValueHeader.indexOf(value) > -1) {
              this.$buefy.toast.open({
                type: 'is-warning',
                message: 'Entered column name is duplicate with existing column.',
                position: 'is-bottom',
                duration: 1500,
              });
            } else {
              const table = this.$refs.tabulator.getInstance();
              table.addColumn({ title: value.toUpperCase(), field: value, editor: true }, false);
              this.tempColumn.push({
                field: value,
                label: value.toUpperCase(),
              });
            }
          } else {
            this.$buefy.toast.open({
              type: 'is-danger',
              message: 'Column name cannot be empty.',
              position: 'is-bottom',
              duration: 1000,
            });
          }
        },
      });
    },
    exportCollection() {
      const id = this.selectedCollectionId;
      const { collectionName } = this.selectedCollection;
      alice
        .exportCollectionById(id)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          const elem = document.getElementById('download-area');
          link.href = url;
          link.setAttribute('download', `export_collection_${collectionName}.xlsx`);
          elem.innerHTML = '';
          elem.appendChild(link);
          link.click();
        })
        .catch(() => {
          // console.log(e, e.response);
          this.isLoading = false;
          this.$buefy.toast.open({
            type: 'is-danger',
            message: 'An error occurred, cannot export collection data.',
            position: 'is-bottom',
          });
        });
    },
    toggleImportCollection(state) {
      document.getElementById('file-input').value = '';
      this.importCollectionOpen = state;
    },
    importCollection() {
      this.importCollectionLoading = true;
      const formData = new FormData();
      const collectionFile = document.querySelector('#file-input');
      formData.append('file', collectionFile.files[0]);
      alice
        .importCollection(formData)
        .then(async () => {
          this.importCollectionLoading = false;
          this.importCollectionOpen = false;
          this.$buefy.toast.open({
            type: 'is-success',
            message: 'Collection imported.',
            position: 'is-bottom',
            duration: 1000,
          });
          await this.loadCollectionList();
        })
        .catch(() => {
          this.importCollectionLoading = false;
          this.importCollectionOpen = false;
          this.$buefy.toast.open({
            type: 'is-danger',
            message: 'Collection import failed.',
            position: 'is-bottom',
            duration: 1000,
          });
        });
    },
    async onAddRow(data) {
      const collectionId = this.selectedCollectionId;
      const { keyName } = this.selectedCollection;
      const key = data[keyName];
      const value = {};
      Object.keys(data).forEach((rowKey) => {
        if (rowKey !== keyName) {
          value[rowKey] = data[rowKey];
        }
      });
      // await this.addKeyValue({ collectionId, key, value });
      this.addKeyValue({ collectionId, key, value })
        .then((response) => {
          if (response.status === 200) {
            this.keyValueData.content.push(response.data.data[0]);
            this.$buefy.toast.open({
              type: 'is-success',
              message: 'Value added.',
              position: 'is-bottom',
              duration: 1000,
            });
            if (this.tempColumn) {
              this.tempColumn = [];
            }
          }
        })
        .catch(() => {
          if (this.tempColumn) {
            this.tempColumn = [];
          }
          this.$buefy.toast.open({
            type: 'is-danger',
            message: 'Add failed or Duplicated key',
            position: 'is-bottom',
            duration: 3000,
          });
        });
      // if (this.tempColumn) {
      //   this.tempColumn = [];
      //   const id = this.selectedCollectionId;
      //   await this.getCollectionHeaderById({ collectionId: id });
      // }
      // await this.togglePage(this.valuePage);
      // this.$buefy.toast.open({
      //   type: 'is-success',
      //   message: 'Value added.',
      //   position: 'is-bottom',
      //   duration: 1000,
      // });
    },
    async onEditRow(data) {
      const result = await this.saveRowFn(data);
      // Check if change
      let colLen = 0;
      if (this.tempColumn) {
        colLen = this.tempColumn.length;
      }
      if (colLen > 0) {
        this.tempColumn = [];
        const id = this.selectedCollectionId;
        await this.getCollectionHeaderById({ collectionId: id });
        await this.togglePage(this.valuePage);
      } else {
        this.updateLocalRowData({
          rowId: result.id,
          rowData: result,
        });
      }
      this.$buefy.toast.open({
        type: 'is-success',
        message: 'Value updated.',
        position: 'is-bottom',
        duration: 1000,
      });
    },
    async onDeleteRow(data) {
      const collectionId = this.selectedCollectionId;
      const { ORIGINAL_ROW_ID: id } = data;
      // await this.deleteKeyValue({ collectionId, id })
      // await this.togglePage(this.valuePage);
      await this.deleteKeyValue({ collectionId, id })
        .then((response) => {
          if (response.status === 200 && response.data.id) {
            const isDeleteIndex = this.keyValueData.content.findIndex((content) => content.id === response.data.id);
            for (const content of this.keyValueData.content) {
              if (content.id === response.data.id) {
                this.keyValueData.content.splice(isDeleteIndex, 1);
                this.$buefy.toast.open({
                  type: 'is-success',
                  message: 'Value removed.',
                  position: 'is-bottom',
                  duration: 1000,
                });
              }
            }
          }
        })
        .catch(() => {
          this.$buefy.toast.open({
            type: 'is-danger',
            message: 'Remove failed.',
            position: 'is-bottom',
            duration: 1000,
          });
        });
      // this.$buefy.toast.open({
      //   type: 'is-success',
      //   message: 'Value removed.',
      //   position: 'is-bottom',
      //   duration: 1000,
      // });
    },
    saveRowFn(editingRow) {
      // console.log(editingRow);
      const exceptKey = editingRow.ORIGINAL_KEY_NAME;
      const valueObject = {};
      Object.keys(editingRow).forEach((eachKey) => {
        if (eachKey !== 'ORIGINAL_KEY_NAME' && eachKey !== 'ORIGINAL_ROW_ID' && eachKey !== 'ORIGINAL_ROW_ORDER' && eachKey !== exceptKey) {
          valueObject[eachKey] = editingRow[eachKey];
        }
      });
      const data = {
        collectionId: this.selectedCollectionId,
        id: editingRow.ORIGINAL_ROW_ID,
        data: {
          id: editingRow.ORIGINAL_ROW_ID,
          collectionId: this.selectedCollectionId,
          key: editingRow[editingRow.ORIGINAL_KEY_NAME],
          value: valueObject,
          order: editingRow.ORIGINAL_ROW_ORDER,
        },
      };
      return this.updateKeyValue(data);
    },
    // fn for tabulator
    addNewRow() {
      this.tabulatorInstance = this.$refs.tabulator.getInstance();
      this.tabulatorInstance.addData([{}], true); // add new row to the top of the table
    },
    onEditCell(cell) {
      const data = cell.getData();
      // console.log(data);
      if (data.ORIGINAL_ROW_ID && data.ORIGINAL_KEY_NAME) {
        this.onEditRow(data);
      } else {
        this.onAddRow(data);
      }
    },
    toggleDeleteRow(e, cell) {
      const row = cell.getRow().getData();
      this.$buefy.dialog.confirm({
        title: 'Remove confirmation',
        message: `Are you sure you are going to remove row "${row[row.ORIGINAL_KEY_NAME] || row.text}" ?`,
        cancelText: 'Keep It',
        confirmText: 'Remove',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.onDeleteRow(row);
        },
      });
    },
    iconRemove() {
      return '<i class="fas fa-trash"></i>';
    },
  },
  computed: {
    ...mapGetters({
      collectionList: 'keyvalue/collectionList',
      keyValueData: 'keyvalue/keyValueData',
      keyValueHeader: 'keyvalue/keyValueHeader',
    }),
    selectedCollection() {
      let target = {};
      if (this.selectedCollectionId) {
        for (let i = 0; i < this.collectionList.length; i += 1) {
          if (this.collectionList[i].id === this.selectedCollectionId) {
            target = this.collectionList[i];
            break;
          }
        }
      }
      return target;
    },
    keyValuePageData() {
      if (this.selectedCollection && this.keyValueData && this.keyValueData.content) {
        return this.keyValueData.content.map((obj) => {
          // TODO key and value header as field name

          const { keyName } = this.selectedCollection;
          const finalObj = {};
          // ID fix
          finalObj.ORIGINAL_KEY_NAME = keyName;
          finalObj.ORIGINAL_ROW_ID = obj.id;
          finalObj.ORIGINAL_ROW_ORDER = obj.order;
          finalObj[keyName] = obj.key;
          this.keyValueHeader.forEach((key) => {
            if (key === 'ORIGINAL_KEY_NAME' || key === 'ORIGINAL_ROW_ID' || key === 'ORIGINAL_ROW_ORDER') {
              console.warn('SKIP forbidden key');
            } else if (!finalObj[key]) {
              if (obj.value[key]) {
                finalObj[key] = obj.value[key];
              } else {
                finalObj[key] = '';
              }
            }
          });
          return finalObj;
        });
      }
      return [];
    },
    keyValueColumn() {
      if (this.selectedCollection && this.keyValueHeader) {
        // const { keyName } = this.selectedCollection;
        const mapKeyValueHeader = this.keyValueHeader.map((key) => ({
          title: key.toUpperCase(),
          field: key,
          editor: 'textarea',
          formatter: 'textarea',
        }));
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.options.columns = [
          // column 1
          {
            headerHozAlign: 'center',
            title: '<i class="fas fa-wrench"></i>',
            formatter: this.iconRemove,
            width: 40,
            hozAlign: 'center',
            cellClick: this.toggleDeleteRow,
          }, ...mapKeyValueHeader];
        return this.options;
        // return this.keyValueHeader.map((key) => ({
        //   field: key,
        //   label: key.toUpperCase(),
        //   isKey: key === keyName,
        // }));
      }
      return [];
    },
    invalidCreateCollectionModal() {
      const name = this.createCollectionData.collectionName || '';
      const key = this.createCollectionData.keyName || '';
      return name.length === 0 || key.length === 0;
    },
  },
};
</script>

<style lang="scss" scoped>

  .tabulator {
    margin-bottom: 0px !important;
    // overflow: none  !important;
  }

  .floating-fab {
    position: absolute;
    bottom: 68px;
    right: 15px;
    box-shadow: 1px 1px 1px 1px #eee;
  }

  .loading-wrapper {
        flex: 1 1 auto;
        margin-right: -1px;
  }
  .loading-block {
    display: flex;
    color: #616161;
    font-size: 1rem;
    align-items: center;
    align-self: center;
  }

.key-value {
  text-align: left;
  .input,
  .button {
    border-radius: 5px;
  }
  .single-page-full {
    display: flex;
    flex-direction: row;
  }
  .collection-menu-item {
    padding: 5px;
    .icon {
      display: inline-block;
      padding: 0 10px;
      width: 32px;
      svg {
        vertical-align: bottom;
      }
    }
  }
  .collection-list {
    flex: 0 0 25%;
    min-width: 250px;
    border-right: 5px solid #eee;
    display: flex;
    flex-direction: column;
    .page-title {
      display: flex;
      flex-direction: row;
      padding: 15px;
      .page-title-text {
        flex: 1 1 auto;
        font-size: 1.25rem;
        font-weight: bold;
      }
      .page-title-control {
        flex: 0 0 auto;
        padding-top: 2px;
      }
    }
    .list-header {
      background-color: #3a4b55;
      font-size: 0.8rem;
      padding: 5px 15px;
      border-color: #ddd;
      border-width: 1px 0 1px 0;
      border-style: solid;
      font-weight: bold;
      color: #888;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .white-text {
        color: #fff;
        padding: 5px 0;
      }
    }
    .list-wrapper {
      flex: 1 1 auto;
      overflow-y: auto;
      overflow-x: hidden;
      background-color: #fff;
      .list-item {
        background-color: #fff;
        padding: 10px 15px;
        border-color: #ddd;
        border-width: 0 0 1px 0;
        border-style: solid;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        &:hover {
          background-color: #bcd3df;
        }
        &.selected {
          font-weight: bold;
          background-color: #2584bb;
          color: #fff;
        }
      }
    }
  }
  .collection-detail {
    flex: 0 1 75%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    position: relative;
    .result-title {
      padding: 15px;
      background-color: #2584bb;
      color: #fff;
      display: flex;
      justify-content: space-between;
      min-height: 58px;
      max-height: 58px;
      .title-text {
        font-weight: bold;
        font-size: 1.25rem;
      }
      .title-tool {
        display: flex;
        .search-bar {
          border-right: 1px solid rgb(144, 190, 219);
          padding-right: 15px;
          padding-top: 2px;
        }
        #collection-detail-menu {
          margin-left: 15px;
        }
      }
    }
    .result-wrapper {
      flex: 1 1 auto;
      overflow: auto;
      margin-right: -1px;
    }
    .table-pagination {
      padding: 10px;
    }
    .footer-bar {
      border-top: 1px solid #ddd;
      background-color: #fafafa;
      padding: 1rem;
      font-size: 0.8rem;
      .pagination {
        justify-content: start;
      }
    }
  }
  .create-collection-modal,
  .import-collection-modal {
    .card {
      border-radius: 3px;
      padding: 20px;
      .card-title {
        font-size: 1.25rem;
        font-weight: bold;
        color: #333;
        margin-bottom: 20px;
      }
      .card-form {
        margin: 10px 0 20px 0;
        .column {
          padding: 0;
          .field-left {
            margin-right: 10px;
          }
          .field-right {
            margin-left: 10px;
          }
        }
        .label {
          color: #305cbb;
        }
      }
      .card-action {
        margin-top: 50px;
        text-align: right;
        .button {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
